// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"81e2e9da","455":"433cef06"}[chunkId] + ".chunk.js";
};